import { RouteObject, useParams } from "react-router-dom";
import { PageContainer } from "../../components/PageContainer";
import { TopBar } from "../../components/TopBar";
import { PermissionedRoutes } from "../../components/PermissionedRoutes";

export const MULTIENTITY_AGGREGATION_ROUTES: RouteObject[] = [
  {
    element: (
      <PermissionedRoutes
        requiredPermissions={["indigo.add_organizationlink", "indigo.view_organization"]}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { MultientitySearch } = await import("./Search");
          return {
            Component() {
              const { userId, orgId } = useParams<{ userId: string; orgId: string }>();

              return (
                <>
                  <TopBar
                    title="Link organizations"
                    backIconOnClick={() => (window.location.href = `/users/${userId}`)}
                  />
                  <PageContainer>
                    <MultientitySearch userId={userId!} orgId={orgId!} />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
      {
        path: "link",
        async lazy() {
          const { MultientityLink } = await import("./Link");
          return {
            Component() {
              const { userId, orgId } = useParams<{ userId: string; orgId: string }>();

              return (
                <>
                  <TopBar
                    title="Link organizations"
                    backIconOnClick={() => (window.location.href = `/users/${userId}`)}
                  />
                  <PageContainer>
                    <MultientityLink userId={userId!} orgId={orgId!} />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
    ],
  },
  {
    element: <PermissionedRoutes requiredPermissions={["indigo.delete_organizationlink"]} />,
    children: [
      {
        path: "unlink",
        async lazy() {
          const { MultientityUnlink } = await import("./Unlink");
          return {
            Component() {
              const { userId, orgId } = useParams<{ userId: string; orgId: string }>();

              return (
                <>
                  <TopBar
                    title="Unlink organizations"
                    backIconOnClick={() => (window.location.href = `/users/${userId}`)}
                  />
                  <PageContainer>
                    <MultientityUnlink userId={userId!} orgId={orgId!} />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
    ],
  },
];
